// services/sobrecustoBiocombustivel.js
import axiosInstance from './axiosInstance';

const SOBRECUSTO_BIOCOMBUSTIVEL_API_URL = '/sobrecusto_biocombustivel';

const sobrecustoBiocombustivelService = {
  async get(idempresa) {
    try {
      const response = await axiosInstance.get(`${SOBRECUSTO_BIOCOMBUSTIVEL_API_URL}/get.php?idempresa=${idempresa}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter sobrecusto biocombustível:', error);
      return [];
    }
  },

  async set(sobrecustoData) {
    try {
      const response = await axiosInstance.post(`${SOBRECUSTO_BIOCOMBUSTIVEL_API_URL}/set.php`, sobrecustoData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar sobrecusto biocombustível:', error);
      throw error;
    }
  },

  async unset(idempresa, idsobrecustobiocombustivel) {
    try {
      const response = await axiosInstance.get(`${SOBRECUSTO_BIOCOMBUSTIVEL_API_URL}/unset.php?idempresa=${idempresa}&idsobrecustobiocombustivel=${idsobrecustobiocombustivel}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover sobrecusto biocombustível:', error);
      throw error;
    }
  }
};

export default sobrecustoBiocombustivelService;
